/* AdhocQueryDetailsViewRenderer.js */

"use strict";
const _ = require("lodash");
const Forms = require("@gluenetworks/forms");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const FormsComponent = Forms.ui.component;
const PopUpWidget = require("@gluenetworks/steve_ui_widgets").PopUp;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const ComboboxControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .ComboBox;

const manageDeviceComponent = require("./subviews/manage_device/ManageDeviceViewComponent");
const childViewComponent = require("../../../../widgets/childview/ChildViewRenderer");
const CreateNewAdhocQuery = require("./veils/name/CreateNewAdhocQueryComponent");
const FileName = require("@gluenetworks/steve_utilities").fileName;

const QueryView = require("./subviews/query_view/QueryViewComponent");
require("moment-duration-format");

class AdhocQueryDetailsViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("adhoc-query-details-view-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;
        this._fileNamer = FileName;

        this._adHocContainer = document.createElement("div");
        this._adHocContainer.classList.add("container-main");
        this._rootElem.appendChild(this._adHocContainer);

        this._lastSearchMethod = undefined;

        this._renderingForm = true;
        this._formsComponent = new FormsComponent();

        this._controlsContainer = document.createElement("div");
        this._controlsContainer.classList.add("controls-container");
        this._adHocQueriesList = new ComboboxControl({
            darkTheme: false,
            placeholder: "AdHoc Queries",
        });
        this._controlsContainer.appendChild(this._adHocQueriesList._renderer._rootElem);

        this._patches = {};
        this._editButtonContainer = document.createElement("edit-button-container");
        this._editButton = new ButtonControl({
            label: "Edit",
            darkTheme: false,
            class: "edit-button-control",
        });
        this._editButtonContainer.appendChild(this._editButton.renderer.rootElement);

        this._buttonsContainer = document.createElement("buttons-container");
        this._saveButton = new ButtonControl({
            label: "Save",
            darkTheme: false,
            class: "save-button-control",
            disabled: true,
        });
        this._deleteButton = new ButtonControl({
            label: "Delete",
            darkTheme: false,
            class: "delete-button-control",
        });

        this._resetButton = new ButtonControl({
            label: "Reset",
            darkTheme: false,
            class: "reset-button-control",
        });

        this._editorViewActionElem = document.querySelectorAll(
            "editor-layout-gl .focused_item game-editor-view-actions-gl left-container"
        );

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Hide Unmatched",
            name: "hideShowUnmatchedResults",
            handler: (this._onHideShowClick = this._onHideShowClick.bind(this)),
        });
        this.model.gameEditor.disableViewAction("hideShowUnmatchedResults");

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Remove Unmatched",
            name: "removeUnmatchedResults",
            handler: (this._onRemoveUnmatchedClick = this._onRemoveUnmatchedClick.bind(this)),
        });
        this.model.gameEditor.disableViewAction("removeUnmatchedResults");

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Select Matched",
            name: "selectmatchedResults",
            handler: (this._onSelectMatchedClick = this._onSelectMatchedClick.bind(this)),
        });
        this.model.gameEditor.disableViewAction("selectmatchedResults");

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Edit Targets",
            name: "editTargets",
            handler: (this._onEditButtonClick = this._onEditButtonClick.bind(this)),
        });

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Download",
            name: "downloadMatches",
            handler: (this._onDownloadClick = this._onDownloadClick.bind(this)),
        });
        this.model.gameEditor.disableViewAction("downloadMatches");

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Run Query",
            name: "searchButton",
            handler: (this._onSearchClick = this._onSearchClick.bind(this)),
        });
        this.model.gameEditor.disableViewAction("searchButton");

        this._devicesChanged = false;

        this._selectedTargetsGrid = undefined;
        this._queryViewComponent = undefined;

        this._configSectionContainer = document.createElement("config-section");
        this._selectedSavedQuery = undefined;

        this._buttonsContainer.appendChild(this._saveButton.renderer.rootElement);
        this._buttonsContainer.appendChild(this._deleteButton.renderer.rootElement);
        this._buttonsContainer.appendChild(this._resetButton.renderer.rootElement);

        this._firstConcept = "";

        this._adHocContainer.appendChild(this._controlsContainer);

        /* User Data - Start */
        this._userDataStorage = this._model._storageFactory.getRemoteStorageInstance(
            "views",
            "adhoc_query_details"
        );
        /* User Data - End */

        this._patch = undefined;

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._adHocQueriesList.on(
            "UserValue",
            (this._onAdHocQueriesListChange = this._onAdHocQueriesListChange.bind(this))
        );
        this._formsComponent.on(
            "PendingPatchesChanged",
            (this._onFormsPendingPatchesChanged = _.debounce(
                this._onFormsPendingPatchesChanged.bind(this),
                500,
                false
            ))
        );

        this._editButton.on(
            "UserClick",
            (this._onEditButtonClick = this._onEditButtonClick.bind(this))
        );

        this._saveButton.on(
            "UserClick",
            (this._onSaveButtonClick = this._onSaveButtonClick.bind(this))
        );
        this._deleteButton.on("UserClick", (this._onDeleteClick = this._onDeleteClick.bind(this)));
        this._resetButton.on("UserClick", (this._onResetClick = this._onResetClick.bind(this)));

        this._model.on("WorkCancel", (this._workCancelClick = this._workCancelClick.bind(this)));
        this._model.on(
            "CheckAndEnableDisableRun",
            (this._onCheckAndEnableDisableRun = this._onCheckAndEnableDisableRun.bind(this))
        );
    }

    _registerFeedListeners() {
        // this._unregisterFeedListeners();
        this._model._adHocQueryResultEntitiesGen.on(
            "RefreshView",
            (this._onFeedRefreshView = this._onFeedRefreshView.bind(this))
        );
    }

    _registerGridListeners() {
        this._selectedTargetsGrid.on(
            "UserRowDoubleClicked",
            (this._onUserDblClickedRow = this._onUserDblClickedRow.bind(this))
        );
        this._selectedTargetsGrid.on(
            "UserSorted",
            (this._onUserSorted = this._onUserSorted.bind(this))
        );
        this._selectedTargetsGrid.on(
            "GridBusyStart",
            (this._onGridBusyStart = this._onGridBusyStart.bind(this))
        );
    }

    _unregisterListeners() {
        this._adHocQueriesList.removeListener("UserValue", this._onAdHocQueriesListChange);
        this._formsComponent.removeListener(
            "PendingPatchesChanged",
            this._onFormsPendingPatchesChanged
        );
        this._editButton.removeListener("UserClick", this._onEditButtonClick);
        this._saveButton.removeListener("UserClick", this._onSaveButtonClick);
        this._deleteButton.removeListener("UserClick", this._onDeleteClick);
        this._resetButton.removeListener("UserClick", this._onResetClick);

        this._model.removeListener("WorkCancel", this._workCancelClick);
        this._model.removeListener("CheckAndEnableDisableRun", this._onCheckAndEnableDisableRun);
    }

    _unregisterFeedListeners() {
        this._model._adHocQueryResultEntitiesGen.removeListener(
            "RefreshView",
            this._onFeedRefreshView
        );
    }

    _unregisterGridListeners() {
        this._selectedTargetsGrid.removeAllListeners("UserRowDoubleClicked");
        this._selectedTargetsGrid.removeListener("UserSorted", this._onUserSorted);
        this._selectedTargetsGrid.removeListener("GridBusyStart", this._onGridBusyStart);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._unregisterGridListeners();
        let promArr = [this._formsComponent.shutdown()];
        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._renderingForm = undefined;
                this._formsComponent = undefined;
                this._devicesChanged = undefined;
                this._selectedTargetsGrid = undefined;
                this._queryViewComponent = undefined;
                this._patch = undefined;
                this._lastSearchMethod = undefined;
                // this._emptyMessage.remove();
                // this._emptyMessage = undefined;
                this._firstConcept = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "DeviceDetailsViewRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    async render() {
        try {
            this._formsComponent.clearPendingPatches();
            if (this._adHocContainer.childNodes.length <= 1) {
                this._adHocContainer.appendChild(this._formsComponent.renderer.rootElement);
            }

            await Promise.all([
                this._model.whenModelIsReady(),
                this._model._modalUserFeedback.displayLoading(),
            ]);
            this._selectedSavedQuery = 0;
            await this._renderAdhocQuery();
            this._registerFeedListeners();
        } catch (err) {
            this._logger.warn({error: err}, "AdHocQueryDetailsViewRenderer.render error");
        } finally {
            this.model._modalUserFeedback.hideDisplayed();
        }
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    set selectedSavedQuery(value) {
        this._selectedSavedQuery = value;
    }

    get selectedSavedQuery() {
        return this.getSelectedSavedQuery();
    }

    getSelectedSavedQuery() {
        this._selectedSavedQuery = this._adHocQueriesList.getValue();
        return this._selectedSavedQuery;
    }

    async _renderAdhocQuery() {
        this._adHocQueriesList.setOptions(this._model.adHocQueryDropdownList);

        const currentAdHocEntity = this._model._adHocQueriesMap[this._selectedSavedQuery];
        const jtype = this._getJtype();
        const pristineValue = this._getPristineValue(currentAdHocEntity);

        this._formsComponent.setTypeInformation(jtype, true);
        this._formsComponent.setPristineValue(pristineValue, true);

        this._renderingForm = true;
        await this._formsComponent.renderer.render();
        this._adHocQueriesList.setValue(0);
        this._renderingForm = false;
        await this._renderConceptItemCommands();
        this._updateButtons();
        this._applyDirtyAndButtons();

        this._generateResultGrid();

        return Promise.resolve();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    isFormValid() {
        const form = this._formsComponent.getValue(),
            queryVal = form.searchField;

        if (_.isEmpty(queryVal) || form.section === "none") {
            return false;
        }
        return true;
    }

    _applyDirtyAndButtons() {
        if (this._model) {
            const currentSelection = this._adHocQueriesList.getValue(),
                currentEntity = this._model._adHocQueriesMap[currentSelection],
                dirty = currentEntity ? currentEntity.isDirty() : false,
                isLastRun =
                    _.get(currentEntity.getPristineProperties(), "name", "") ===
                    this._model.activeOrgId;
            this._formsComponent.renderer.rootElement.classList.remove("disabled-form");
            if (currentSelection === 0) {
                this._model._setDirty(dirty);
                this._toggleDeleteButton(false);
                this._toggleResetButton(dirty);
                if (this.isFormValid()) {
                    this._saveButton.setDisabled(false);
                    if (!_.isEmpty(this._model._selectedResults)) {
                        this._model.gameEditor.enableViewAction("searchButton");
                    } else {
                        this._model.gameEditor.disableViewAction("searchButton");
                    }
                } else {
                    this._saveButton.setDisabled(true);
                    this._model.gameEditor.disableViewAction("searchButton");
                }
            } else if (isLastRun) {
                this._model._setDirty(false);
                this._toggleDeleteButton(false);
                this._toggleResetButton(false);
                this._saveButton.setDisabled(false);
                this._formsComponent.renderer.rootElement.classList.add("disabled-form");
                this._model.gameEditor.disableViewAction("searchButton");
            } else {
                if (dirty) {
                    this._model._setDirty(true);
                    this._toggleDeleteButton(false);
                    this._toggleResetButton(true);
                    if (this.isFormValid()) {
                        this._saveButton.setDisabled(false);
                        if (!_.isEmpty(this._model._selectedResults)) {
                            this._model.gameEditor.enableViewAction("searchButton");
                        } else {
                            this._model.gameEditor.disableViewAction("searchButton");
                        }
                    } else {
                        this._saveButton.setDisabled(true);
                        this._model.gameEditor.disableViewAction("searchButton");
                    }
                } else {
                    this._model._setDirty(false);
                    this._toggleDeleteButton(true);
                    this._toggleResetButton(false);
                    this._saveButton.setDisabled(true);
                    if (this.isFormValid() && !_.isEmpty(this._model._selectedResults)) {
                        this._model.gameEditor.enableViewAction("searchButton");
                    } else {
                        this._model.gameEditor.disableViewAction("searchButton");
                    }
                }
            }
        }
    }

    _onFormsPendingPatchesChanged() {
        if (!this._renderingForm) {
            if (_.isEmpty(this._formsComponent)) {
                return;
            }

            this._updateEntityOnChange();

            // this._updateFilterDropdowns();
            this._renderConceptItemCommands();

            this._applyDirtyAndButtons();
        }
    }

    _onEditButtonClick() {
        this._manageDeviceComponent = new manageDeviceComponent(this._model);

        this._manageDeviceComponent.renderer.render().then(() => {
            this._childViewRenderer = new childViewComponent({
                data: this._manageDeviceComponent.renderer.rootElement,
                backLink: "Details",
                title: "Manage Devices",
                childData: this._manageDeviceComponent,
                parentData: this._model,
                backButton: true,
            });
        });
    }

    async _onAdHocQueriesListChange(value) {
        let fromLastRun = false;
        if (
            !_.isEmpty(this._model._selectedSavedQuery) &&
            !_.isEmpty(this._model._adHocQueriesMap[this._model._selectedSavedQuery]) &&
            _.get(
                this._model._adHocQueriesMap[
                    this._model._selectedSavedQuery
                ].getPristineProperties(),
                "name",
                ""
            ) === this._model.activeOrgId
        ) {
            fromLastRun = true;
        }
        this._model._adHocRun = false;

        this._model._selectedSavedQuery = value;
        const currentAdHocEntity = this._model._adHocQueriesMap[this._model._selectedSavedQuery],
            pristineValues = this._getPristineValue(currentAdHocEntity),
            isLastRun =
                _.get(currentAdHocEntity.getPristineProperties(), "name", "") ===
                this._model.activeOrgId;

        if (pristineValues.searchMethod === "COMMAND") {
            const commandSets = Object.keys(this._model._commandSetsFeed.getCache());
            commandSets.push("all");
            const commandSetExists = commandSets.indexOf(pristineValues.commandSet) > -1;

            if (!commandSetExists) {
                pristineValues.commandSet = "all";
                pristineValues.commandSetResults = "all";

                const err = {
                    errorCode: "",
                    errorMsg: "The command set used in this query is no longer available.",
                    title: "Command Set Not Found",
                };
                this._model._modalUserFeedback.displayError(err);
            }
        }

        this._formsComponent.setPristineValue(pristineValues);
        this._model._lastRunSelected = false;
        let flag = false;
        if (isLastRun || fromLastRun) {
            if (isLastRun) {
                flag = true;
                this._model._lastRunSelected = true;
            } else if (fromLastRun === true) {
                flag = false;
            }
        }
        await this._updateResults(flag);

        this._enableAllViewActions();
    }

    _updateResults(passedVal = false) {
        this._devicesChanged = true;

        const query = this._model._createQuery(
            passedVal ? this._model._devicesInProxyRun : this._model._selectedResults
        );
        let recall = false;
        if (this._model._noDevicesSelected) {
            recall = true;
        }
        return this._model._reestablishResultsFeed(query, recall).then(() => {
            this._selectedTargetsGrid.refreshView();
        });
    }

    async _onSaveButtonClick() {
        await this._saveUserData();
    }

    async _onDeleteClick() {
        const name = this._model._adHocQueriesMap[this._adHocQueriesList.getValue()].getName();
        try {
            await this.model._modalUserFeedback.displayConfirmation(
                `Are you sure you want to delete "${name}"?\n`,
                {
                    title: "Delete Confirmation",
                    confirmDetails: {
                        text: "Delete",
                        type: "destructive",
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text",
                    },
                }
            );

            await this._model.deleteAdHocQuery(this._adHocQueriesList.getValue());

            await this._model.updateAdHocDropdown();
            this._adHocQueriesList.setOptions(this._model.adHocQueryDropdownList);
            this._adHocQueriesList.setValue(0);

            this._updateFormPristine();
        } catch (err) {
            this._logger.warn({error: err}, "AdHocQueryDetailsViewRenderer._onDeleteClick()");
        }
    }

    _onResetClick() {
        this.model._modalUserFeedback
            .displayConfirmation("Are you sure you want to Discard your changes?", {
                title: "Reset Changes",
                confirmDetails: {
                    text: "Discard",
                    type: "destructive",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            })
            .then(() => {
                this._formsComponent.clearPendingPatches();
                this._model._adHocQueriesMap[
                    this._adHocQueriesList.getValue()
                ].clearPendingPatches();
                this._model._proxyAdHocQueryEntity.clearPendingPatches();
                this._updateFormPristine();
            })
            .catch(() => {
                this.model._modalUserFeedback.hideDisplayed();
            });
    }

    async _onSearchClick() {
        this._formsComponent.renderer.rootElement.classList.add("disabled-form");

        this._disableAllViewActions();

        const form = this._formsComponent.getValue();

        const searchField = form.searchField,
            searchMethod = form.searchMethod,
            justRun = this._adHocQueriesList.getValue(),
            objSearch = {};

        Object.assign(objSearch, {
            regex: searchField,
            searchMethod,
            justRun,
            contentSource: searchMethod,
        });

        if (searchMethod === "COMMAND") {
            Object.assign(objSearch, {
                commandSet: form.commandSet || "all",
            });

            if (form.commandSetResults === "all") {
                Object.assign(objSearch, {
                    commandSetResult: {
                        type: "all",
                    },
                });
            } else if (form.commandSetResults === "basicMode") {
                Object.assign(objSearch, {
                    commandSetResult: {
                        type: "basicMode",
                    },
                });
            } else if (form.commandSetResults.indexOf("rsi-id.") > -1) {
                const rsiId = form.commandSetResults.replace(/rsi-id./, "");
                Object.assign(objSearch, {
                    commandSetResult: {
                        type: "restSyncItems",
                        restSyncItemId: rsiId,
                    },
                });
            } else if (form.commandSetResults.indexOf("show-command.") > -1) {
                const command = form.commandSetResults.replace(/show-command./, "");
                Object.assign(objSearch, {
                    commandSetResult: {
                        type: "cliCommands",
                        command: command,
                    },
                });
            } else if (form.commandSetResults.indexOf("concept-item.") > -1) {
                const conceptItemId = form.commandSetResults.replace(/concept-item./, "");
                Object.assign(objSearch, {
                    commandSetResult: {
                        type: "conceptItems",
                        restSyncItemId: conceptItemId,
                    },
                });
            } else if (form.commandSetResults.indexOf("get-url.") > -1) {
                const getURLVal = form.commandSetResults.replace(/get-url./, "");
                Object.assign(objSearch, {
                    commandSetResult: {
                        type: "getUrls",
                        restSyncItemId: getURLVal,
                    },
                });
            }
        } else if (searchMethod === "SHOW") {
            Object.assign(objSearch, {
                showCommands: form.show.split("\n") || [],
            });
        } else if (searchMethod === "SECTION") {
            Object.assign(objSearch, {
                conceptItemId:
                    form.section === "none" ? undefined : form.section.replace(/concept-item./, ""),
            });
        }

        this._model.searchClick(objSearch);
    }

    _onUserDblClickedRow(obj) {
        if (event.target.nodeName === "LINKS-COLUMN") {
            return;
        }

        const selectedResultEntity = this._model._adHocQueryResultEntitiesGen.getEntityById(
            obj.selectedRow
        );

        if (
            !_.isEmpty(selectedResultEntity) &&
            (selectedResultEntity.getStatus() !== "COMPLETE" ||
                !_.isUndefined(selectedResultEntity.getErrorMsg()))
        ) {
            return;
        }

        if (!this._model._adHocRun && !this._model._lastRunSelected) {
            return;
        }

        let deviceList = [];
        const deviceResultMap = {};
        deviceList = Object.values(this._model._adHocQueryResultEntitiesGen._feed.getCache()).map(
            (result) => {
                Object.assign(deviceResultMap, {[result.getDeviceId()]: result});
                return result.getDeviceId();
            }
        );
        deviceList = this._model.getDeviceOptionsForQueryView(deviceList);

        let device = selectedResultEntity.getDeviceId();
        // const form = this._formsComponent.getValue(),
        const pristineValues = this._model._proxyAdHocQueryEntity.getPristineProperties();

        const searchField = pristineValues.query || "",
            searchType = pristineValues.source || "LATEST",
            searchMethod = pristineValues.filter || "NONE",
            conceptItem = pristineValues.conceptItemId || "",
            showCommand = pristineValues.showCommands || "";
        this._queryViewComponent = new QueryView({
            device: device,
            deviceList,
            deviceResultMap,
            query: searchField,
            searchType: searchType,
            matches: this._model._matchCount,
            parentRenderer: this,
            jobEntityDef: this._model._jobEntityDef,
            selectedResultEntity,
            searchMethod,
            conceptItem,
            showCommand,
        });

        this._queryViewComponent.renderer.render().then(() => {
            this._childViewRenderer = new childViewComponent({
                data: this._queryViewComponent.renderer.rootElement,
                backLink: "Ad Hoc Query",
                title: "Query Results",
                childData: this._queryViewComponent,
                parentData: this._model,
                backButton: true,
            });
        });
    }
    _onUserSorted(eventData) {
        this._model.onUserSorted(eventData);
    }

    _onGridBusyStart() {
        if (this._model.pagingFeed.totalEntities > this._model.pagingFeed.pageSize * 2) {
            let gridBusyEnded = false;
            this._selectedTargetsGrid.once("GridBusyEnd", () => {
                gridBusyEnded = true;
            });
            this._model._modalUserFeedback.displayLoading().then(() => {
                if (gridBusyEnded) {
                    this._model._modalUserFeedback.hideDisplayed();
                } else {
                    this._selectedTargetsGrid.once("GridBusyEnd", () => {
                        this._model._modalUserFeedback.hideDisplayed();
                    });
                }
            });
        }
    }

    _onCheckAndEnableDisableRun() {
        if (!_.isEmpty(this._model._selectedResults) && this.isFormValid()) {
            this._model.gameEditor.enableViewAction("searchButton");
        } else {
            this._model.gameEditor.disableViewAction("searchButton");
        }
    }

    async _workCancelClick() {
        await this._model.updateAdHocDropdown();
        this._adHocQueriesList.setOptions(this._model.adHocQueryDropdownList);
        this._adHocQueriesList.setValue(this._model._justRunAdHoc);

        let query = this._model._createQuery(this._model._selectedResults);
        await this._model._reestablishResultsFeed(query);
        this._selectedTargetsGrid.refreshView();

        const status = this._model._adHocQueryExecutionEntityGen.getStatus();
        if (status === "COMPLETE" || status === "ERROR") {
            this._model._justSaved = true;
            this._reenableConfigScreen();
            this._enableAllViewActions();
        }
    }

    _reenableConfigScreen() {
        this._configSectionContainer.classList.remove("disabled-form");
        this._formsComponent.renderer.rootElement.classList.remove("disabled-form");
        this._enableAllViewActions();
        this._model.gameEditor.enableViewAction("searchButton");
    }

    _disableConfigScreen() {
        this._configSectionContainer.classList.add("disabled-form");
        this._formsComponent.renderer.rootElement.classList.add("disabled-form");
    }

    _disableConfigFormForLatest() {
        this._formsComponent.renderer.rootElement
            .querySelector(".choice_options_contents")
            .classList.add("disabled-form");

        this._enableAllViewActions();

        this.model.gameEditor.disableViewAction("editTargets");
        this.model.gameEditor.disableViewAction("searchButton");

        this._saveButton.setDisabled(false);
        this._toggleDeleteButton(false);
        this._toggleResetButton(false);
    }

    _enableConfigFormFromLatest() {
        this._formsComponent.renderer.rootElement
            .querySelector(".choice_options_contents")
            .classList.remove("disabled-form");

        this.model.gameEditor.enableViewAction("editTargets");
        this.model.gameEditor.enableViewAction("downloadMatches");
        this.model.gameEditor.enableViewAction("hideShowUnmatchedResults");
        this.model.gameEditor.enableViewAction("removeUnmatchedResults");
        this.model.gameEditor.enableViewAction("selectmatchedResults");

        this._saveButton.setDisabled(false);
        this._toggleDeleteButton(false);
        this._toggleResetButton(false);
    }

    _onFeedRefreshView() {
        if (this._model) {
            let totalEntities = this._model.pagingFeed.totalEntities;

            if (totalEntities === 0) {
                if (
                    _.get(this._adhocDetails, "_adHocRun", false) ||
                    _.get(this._adhocDetails, "_lastRunSelected", false)
                ) {
                    totalEntities = this._model._devicesInProxyRun.length;
                } else {
                    totalEntities = this._model._selectedResults.length;
                }
            }

            if (totalEntities === 0) {
                this._showDefaultMessageDisplay();
            } else {
                this._hideDefaultMessageDisplay();
            }
        }
    }

    async _onDownloadClick() {
        this.model.gameEditor.disableViewAction("downloadMatches");
        this._model._devicesIdNameMap = {};
        const selectedResults = this._getUpdatedSelectedRows();
        let visibleResults;
        visibleResults = this._model._adHocQueryResultEntitiesGen._entityOrder;
        const resultsFromInitialRequest = _.get(this._model, "_selectedResults", false);

        if (resultsFromInitialRequest) {
            visibleResults = resultsFromInitialRequest;
        }

        if (this._selectedSavedQuery === 0) {
            visibleResults = this._model._devicesInProxyRun;
        }
        if (!visibleResults) {
            visibleResults = [];
        }

        // if(!_.isEmpty(this._model._matchCount) || this._model._matchCount > 0) {
        const form = this._formsComponent.getValue(),
            searchType = form.searchType,
            searchMethod = form.searchMethod,
            matchedResultIds =
                selectedResults && selectedResults.length > 0 ? selectedResults : visibleResults;
        let fileConfig = {};

        const getConfiguration = async (result, searchType, searchMethod) => {
            const rawConfig = await this._model.getDeviceConfig(result, searchType, searchMethod);
            let currentEntity = result;
            if (!_.isEmpty(rawConfig)) {
                fileConfig[
                    `${this._filterName(
                        this._model._devicesIdNameMap[currentEntity.getDeviceId()]
                    )}.txt`
                ] = {
                    type: "text/plain",
                    content: rawConfig,
                };
            }
            return Promise.resolve();
        };

        const results = await this._model._adHocQueryResultEntitiesDef.loadAdHocQueryResults(
            this._model.activeOrgId,
            {id: {$in: matchedResultIds}},
            {
                status: true,
                deviceId: true,
                deviceName: true,
                deviceDescription: true,
                deviceDetectedTypeBase: true,
                deviceDetectedTypeName: true,
                deviceIp: true,
                deviceDetectedVendor: true,
                detectedRawVendor: true,
                deviceDetectedRawOs: true,
                deviceDetectedSerialNumber: true,
                matchCount: true,
                queriedData: true,
                errorMsg: true,
                jobIds: true,
            },
            {deviceName: 1},
            {skip: 0, limit: matchedResultIds.length}
        );

        await Promise.all(
            results.map((result) => getConfiguration(result, searchType, searchMethod))
        );

        const fileContentCsv = this._createContentForCSV(results);

        let fileName = this._fileNamer({
            solution: "DM",
            general: "AdhocQueryResults",
            suffix: "zip",
        });

        fileConfig[`AdHoc_Query_Summary.csv`] = {type: "text/plain", content: fileContentCsv};
        // let fileName = "AdHoc_Query_Results.zip";
        this.model._steveIo.fileFactory.saveStringsAsZip(fileConfig, fileName);
        this.model.gameEditor.enableViewAction("downloadMatches");
        // }
    }

    _createContentForCSV(results) {
        const sourceValues = {
            DEFAULT: "Default Configuration Snapshot",
            LATEST: "Latest Configuration Snapshot",
            DEVICE: "Device",
            STATE: "Latest State Snapshot",
        };
        let data = "";
        const selectedQueryId = this._adHocQueriesList.getValue(),
            form = this._formsComponent.getValue(),
            selectedAdHoc = this._model._adHocQueriesMap[this._adHocQueriesList.getValue()],
            name =
                selectedQueryId === 0 || selectedAdHoc.getName() === this._model.activeOrgId
                    ? "<None>"
                    : selectedAdHoc.getName(),
            source = sourceValues[form["searchType"]],
            query = form["searchField"];

        data = `Query name: ,${name}\n`;
        data += `Source: ,${source}\n`;

        if (form["searchMethod"] === "NONE") {
            data += `Filter: , <None>\n`;
        } else if (form["searchMethod"] === "CONCEPT") {
            data += `Filter: ,Concept Item\n`;
            data += `Concept Item: ,${this._model._conceptItems[form["conceptItems"]].label}\n`;
        } else if (form["searchMethod"] === "SHOW") {
            data += `Filter: , Command\n`;
            data += `Commands: ,"${form["show"].replace(/\n/g, ", ")}"\n`;
        }

        data += `Query: , ${query}\n`;

        data +=
            "Type, Name, Desc, IP Address, Vendor, Serial, Match Count, Query Status, Message \n";
        results.forEach((resultEntity) => {
            // const resultEntity = this._model._adHocQueryResultEntitiesGen.getResultEntityById(id);
            data += `${resultEntity.getDeviceDetectedTypeBase() || ""}, ${
                resultEntity.getDeviceName() || ""
            },"${resultEntity.getDeviceDescription() || ""}",`;
            data += `${resultEntity.getDeviceIp() || ""}, ${
                resultEntity.getDeviceDetectedVendor() || ""
            }, ${resultEntity.getDeviceDetectedSerialNumber() || ""},`;
            data += `${resultEntity.getMatchCount() || "0"}, ${resultEntity.getStatus() || ""}, ${
                resultEntity.getErrorMsg() || ""
            }\n`;
        });

        return data;
    }

    _onRemoveUnmatchedClick() {
        let results = [];
        let resultsToSearch = [];
        if (!this._model._lastRunSelected) {
            resultsToSearch = this._model._selectedResults;
        } else {
            resultsToSearch = this._model._devicesInProxyRun;
        }
        if (
            this._model._adHocQueryResultEntitiesGen &&
            this._model._adHocQueryResultEntitiesGen._feed.getCache()
        ) {
            Object.values(this._model._adHocQueryResultEntitiesGen._feed.getCache()).forEach(
                (eachEntity) => {
                    if (_.indexOf(resultsToSearch, eachEntity.getId()) > -1) {
                        if (
                            eachEntity &&
                            eachEntity.getMatchCount() &&
                            eachEntity.getMatchCount() > 0
                        ) {
                            results.push(eachEntity.getId());
                        }
                    }
                }
            );
        }

        resultsToSearch = resultsToSearch.filter((item) => _.includes(results, item));
        this.model.gameEditor.disableViewAction("hideShowUnmatchedResults");
        this.model.gameEditor.disableViewAction("removeUnmatchedResults");
        this.model.gameEditor.enableViewAction("selectmatchedResults");

        this._model._selectedResults = resultsToSearch;

        const newResultEntities = this._model._adHocQueryResultEntitiesGen.getResultEntitiesById(
            this._model._selectedResults
        );
        if (!_.isEmpty(newResultEntities)) {
            this._model._selectedDevices = [];
            newResultEntities.forEach((result) =>
                this._model._selectedDevices.push(result.getDeviceId())
            );
        }

        /* Reestablish feed */
        let query = this._model._createQuery(resultsToSearch);
        this._model._reestablishResultsFeed(query);
    }

    _onSelectMatchedClick() {
        let results = [],
            resultsToSearch = [],
            devices = [];

        if (!this._model._lastRunSelected) {
            resultsToSearch = this._model._selectedResults;
        } else {
            resultsToSearch = this._model._devicesInProxyRun;
        }
        if (
            this._model._adHocQueryResultEntitiesGen &&
            this._model._adHocQueryResultEntitiesGen._feed.getCache()
        ) {
            Object.values(this._model._adHocQueryResultEntitiesGen._feed.getCache()).forEach(
                (eachEntity) => {
                    if (_.indexOf(resultsToSearch, eachEntity.getId()) > -1) {
                        if (
                            eachEntity &&
                            eachEntity.getMatchCount() &&
                            eachEntity.getMatchCount() > 0
                        ) {
                            results.push(eachEntity.getId());
                            devices.push(eachEntity.getDeviceId());
                        }
                    }
                }
            );
        }

        this._model._gameEditor._LMRBLayout.emit("SelectRowsOnDeviceGrid", devices);
        if (this._selectedTargetsGrid) {
            this._selectedTargetsGrid.setSelectedRows(results);
        }
    }

    _showDefaultMessageDisplay() {
        // this._configSectionContainer.appendChild(this._emptyMessage);
    }

    _hideDefaultMessageDisplay() {
        // this._emptyMessage.remove();
    }

    _onHideShowClick() {
        this._model._toggleMode = !this._model._toggleMode;
        let resultsToSearch = [];
        if (!this._model._lastRunSelected) {
            resultsToSearch = this._model._selectedResults;
        } else {
            resultsToSearch = this._model._devicesInProxyRun;
        }

        if (!this._model._toggleMode) {
            this._model._setViewActionText("hideShowUnmatchedResults", "Show Unmatched");
            let results = [];
            if (
                this._model._adHocQueryResultEntitiesGen &&
                this._model._adHocQueryResultEntitiesGen._feed.getCache()
            ) {
                Object.values(this._model._adHocQueryResultEntitiesGen._feed.getCache()).forEach(
                    (eachEntity) => {
                        if (_.indexOf(resultsToSearch, eachEntity.getId()) > -1) {
                            if (
                                eachEntity &&
                                eachEntity.getMatchCount() &&
                                eachEntity.getMatchCount() > 0
                            ) {
                                results.push(eachEntity.getId());
                            }
                        }
                    }
                );
            }
            this._model._reestablishResultsFeed(this._model._createQuery(results)).then(() => {
                this._selectedTargetsGrid.refreshView();
            });
        } else {
            this._model._setViewActionText("hideShowUnmatchedResults", "Hide Unmatched");
            this._model
                ._reestablishResultsFeed(this._model._createQuery(resultsToSearch))
                .then(() => {
                    this._selectedTargetsGrid.refreshView();
                });
        }
    }

    /*******************************************/
    /* END PRIVATE ACTION METHODS              */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/
    _updateFormPristine() {
        const pristineValue = this._getPristineValue(
            this._model._adHocQueriesMap[this._adHocQueriesList.getValue()]
        );
        this._formsComponent.setPristineValue(pristineValue);
    }

    async _saveUserData() {
        const currentSelection = this._adHocQueriesList.getValue() || 0,
            currentAdHocEntity = this._model._adHocQueriesMap[currentSelection];
        let isLastRun = false;
        if (
            _.get(currentAdHocEntity.getPristineProperties(), "name", "") ===
            this._model.activeOrgId
        ) {
            isLastRun = true;
            this._model._lastRunSelected = false;
        }

        if (isLastRun || !this._model._adHocQueriesMap[currentSelection].isSynchronized()) {
            return this.model._modalUserFeedback
                .displayCustom(
                    new CreateNewAdhocQuery(
                        this._model._logger,
                        this._model._userSession,
                        this._model._adHocQueriesMap[currentSelection],
                        this.model._modalUserFeedback,
                        this
                    ),
                    {dontHide: true}
                )
                .then(() => {
                    return this._model.updateAdHocDropdown();
                })
                .then(() => {
                    this._adHocQueriesList.setOptions(this._model.adHocQueryDropdownList);
                    this._adHocQueriesList.setValue(this._model._preSelect);
                    return Promise.resolve();
                })
                .then(() => {
                    this._updateFormPristine();
                    return Promise.resolve();
                })
                .then(() => {
                    this._updateEntityOnChange();
                    return Promise.resolve();
                })
                .then(() => {
                    this._updateResults();
                    return Promise.resolve();
                })
                .then(() => {
                    this._applyDirtyAndButtons();
                    return Promise.resolve();
                })
                .catch((err) => {
                    this._logger.info(
                        {error: err},
                        "AdHocQueryDetailsViewRenderer._saveUserData()"
                    );
                })
                .finally(() => {
                    // this._model._justSaved = true;
                    // this._model._proxyAdHocQueryEntity = {};
                    return this.model._modalUserFeedback.hideDisplayed();
                });
        } else {
            await this._model.saveAdHocQuery(this._model._adHocQueriesMap[currentSelection]);
            this._model._justSaved = true;
            // this._model._modalUserFeedback.displayLoading();
            // await this.render(false, false);
            this._applyDirtyAndButtons();
            return Promise.resolve();
            // return this.model._modalUserFeedback.hideDisplayed();
        }
    }

    _getJtype() {
        let conceptItems = this.model.conceptItems,
            conceptItemsValues = Object.keys(conceptItems),
            defaultConceptItemValues = [],
            defaultConceptItemLabels = [];

        const sectionListAll = [{value: "none", label: " None"}];
        this._getAllRSIIds(sectionListAll);
        this._getAllConceptItems(sectionListAll);

        conceptItemsValues.forEach((key) => {
            let item = conceptItems[key];
            defaultConceptItemValues.push(key);
            defaultConceptItemLabels.push(item.label);
        });

        const jtype = {};

        jtype.searchType = "";
        jtype["searchType@Required"] = true;
        jtype["searchType@Display.label"] = "Source";

        if (this._model._isCDSolutionAvailable) {
            jtype["searchType@Select.options"] = {
                DEFAULT: {
                    "searchMethod@Select.options": {
                        NONE: {
                            section: "ANY",
                            "section@Required": true,
                            "section@Enum": ["ANY"],
                            "section@Display.label": "Section",
                            "section@Display.enum": ["Any"],
                            "section@Display.readOnly": true,
                        },
                        COMMAND: {
                            "commandSet@Select.options": this.getCommandSets(true, false),
                            "commandSet@Required": true,
                            commandSet: "all",
                            "commandSet@Display.label": "Command Set",
                        },
                        SECTION: {
                            section: "none",
                            "section@Required": true,
                            "section@Enum": sectionListAll.map((i) => i.value),
                            "section@Display.label": "Section",
                            "section@Display.enum": sectionListAll.map((i) => i.label),
                            "section@Display.readOnly": false,
                        },
                        "NONE@Display.label": "All (Full Snapshot)",
                        "COMMAND@Display.label": "By Command Set",
                        "SECTION@Display.label": "By Section",
                    },
                    "searchMethod@Required": true,
                    "searchMethod@Display.label": "Filter",
                    searchMethod: "NONE",
                },
                DEVICE: {
                    "searchMethod@Select.options": {
                        NONE: {
                            section: "ANY",
                            "section@Required": true,
                            "section@Enum": ["ANY"],
                            "section@Display.label": "Section",
                            "section@Display.enum": ["Any"],
                            "section@Display.readOnly": true,
                        },
                        COMMAND: {
                            "commandSet@Select.options": this.getCommandSets(true, true),
                            "commandSet@Required": true,
                            commandSet: "all",
                            "commandSet@Display.label": "Command Set",
                        },
                        SECTION: {
                            section: "none",
                            "section@Required": true,
                            "section@Enum": sectionListAll.map((i) => i.value),
                            "section@Display.label": "Section",
                            "section@Display.enum": sectionListAll.map((i) => i.label),
                            "section@Display.readOnly": false,
                        },
                        SHOW: {
                            show: "",
                            "show@Display.label": "Show Command",
                            "show@Display.editor": {
                                minLineCount: 4,
                                maxLineCount: 4,
                            },
                        },
                        "NONE@Display.label": "All (Full Snapshot)",
                        "COMMAND@Display.label": "By Command Set",
                        "SECTION@Display.label": "By Section",
                        "SHOW@Display.label": "By Show Command",
                    },
                    "searchMethod@Required": true,
                    "searchMethod@Display.label": "Filter",
                    searchMethod: "NONE",
                },
                LATEST: {
                    "searchMethod@Select.options": {
                        NONE: {
                            section: "ANY",
                            "section@Required": true,
                            "section@Enum": ["ANY"],
                            "section@Display.label": "Section",
                            "section@Display.enum": ["Any"],
                            "section@Display.readOnly": true,
                        },
                        COMMAND: {
                            "commandSet@Select.options": this.getCommandSets(true, false),
                            "commandSet@Required": true,
                            commandSet: "all",
                            "commandSet@Display.label": "Command Set",
                        },
                        SECTION: {
                            section: "none",
                            "section@Required": true,
                            "section@Enum": sectionListAll.map((i) => i.value),
                            "section@Display.label": "Section",
                            "section@Display.enum": sectionListAll.map((i) => i.label),
                            "section@Display.readOnly": false,
                        },
                        "NONE@Display.label": "All (Full Snapshot)",
                        "COMMAND@Display.label": "By Command Set",
                        "SECTION@Display.label": "By Section",
                    },
                    "searchMethod@Required": true,
                    "searchMethod@Display.label": "Filter",
                    searchMethod: "NONE",
                },
                STATE: {
                    "searchMethod@Select.options": {
                        NONE: {
                            section: "ANY",
                            "section@Required": true,
                            "section@Enum": ["ANY"],
                            "section@Display.label": "Section",
                            "section@Display.enum": ["Any"],
                            "section@Display.readOnly": true,
                        },
                        COMMAND: {
                            "commandSet@Select.options": this.getCommandSets(false, true),
                            "commandSet@Required": true,
                            commandSet: "all",
                            "commandSet@Display.label": "Command Set",
                        },
                        "NONE@Display.label": "All (Full Snapshot)",
                        "COMMAND@Display.label": "By Command Set",
                        "SECTION@Display.label": "By Section",
                    },
                    "searchMethod@Required": true,
                    "searchMethod@Display.label": "Filter",
                    searchMethod: "NONE",
                },

                "DEFAULT@Display.label": "Default Configuration Snapshot",
                "DEVICE@Display.label": "Device",
                "LATEST@Display.label": "Latest Configuration Snapshot",
                "STATE@Display.label": "Latest Operational Snapshot",
            };
        } else {
            jtype["searchType@Select.options"] = {
                LATEST: {
                    "searchMethod@Select.options": {
                        NONE: {
                            section: "ANY",
                            "section@Required": true,
                            "section@Enum": ["ANY"],
                            "section@Display.label": "Section",
                            "section@Display.enum": ["Any"],
                            "section@Display.readOnly": true,
                        },
                        SECTION: {
                            section: "none",
                            "section@Required": true,
                            "section@Enum": sectionListAll.map((i) => i.value),
                            "section@Display.label": "Section",
                            "section@Display.enum": sectionListAll.map((i) => i.label),
                            "section@Display.readOnly": false,
                        },
                        "NONE@Display.label": "All (Full Snapshot)",
                        "SECTION@Display.label": "By Section",
                    },
                    "searchMethod@Required": true,
                    "searchMethod@Display.label": "Filter",
                    searchMethod: "NONE",
                },
                "LATEST@Display.label": "Latest Configuration Snapshot",
            };
        }

        jtype.searchField = "";
        jtype["searchField@Display.label"] = "Query";
        jtype["searchField@Display.placeholder"] = "Regular Expression";

        return jtype;
    }

    getCommandSets(getDriftAndAudit = false, getAuditOnly = true) {
        const jtype = {};
        let isBasicModeEnabled = false;

        // Get ConfigAndAudit or AuditOnly commandSets based on need
        let dataType = [];
        if (getDriftAndAudit) {
            dataType.push("DRIFT_AND_AUDIT");
        }
        if (getAuditOnly) {
            dataType.push("AUDIT_ONLY");
        }

        const commandResultListAll = [{value: "all", label: " All"}];
        this._getAllRSIIds(commandResultListAll);
        this._getAllConceptItems(commandResultListAll);

        let noCommandSets = true;

        _.values(_.get(this._model._commandSetsFeed, "cache"))
            .filter((commandSet) => dataType.indexOf(commandSet.getDataType()) > -1) // Get ConfigNAudit or AuditOnly commandSets based on need
            .forEach((commandSet) => {
                noCommandSets = false;
                const commandSetResultList = [{value: "all", label: " All"}];
                this._getConceptItems(commandSet, commandSetResultList);
                this._getRSIIds(commandSet, commandSetResultList);
                this._getGetURLs(commandSet, commandSetResultList);
                this._getShowCommands(commandSet, commandSetResultList);

                if (commandSet.getBasicMode()) {
                    isBasicModeEnabled = true;

                    commandSetResultList.splice(1, 0, {
                        value: "basicMode",
                        label: " Standard",
                    });
                }

                jtype[commandSet.getId()] = {
                    commandSetResults: "all",
                    "commandSetResults@Required": true,
                    "commandSetResults@Enum": commandSetResultList.map((i) => i.value),
                    "commandSetResults@Display.label": "Command Result",
                    "commandSetResults@Display.enum": commandSetResultList.map((i) => i.label),
                    "commandSetResults@Display.readOnly": false,
                };
                jtype[commandSet.getId() + "@Display.label"] = _.trim(commandSet.getName());
            });

        if (isBasicModeEnabled) {
            commandResultListAll.splice(1, 0, {
                value: "basicMode",
                label: " Standard",
            });
        }

        if (noCommandSets) {
            jtype["all"] = {
                commandSetResults: "basicMode",
                "commandSetResults@Required": true,
                "commandSetResults@Enum": ["basicMode"],
                "commandSetResults@Display.label": "Command Result",
                "commandSetResults@Display.enum": ["Standard"],
                "commandSetResults@Display.readOnly": true,
            };
        } else {
            jtype["all"] = {
                commandSetResults: "all",
                "commandSetResults@Required": true,
                "commandSetResults@Enum": commandResultListAll.map((i) => i.value),
                "commandSetResults@Display.label": "Command Result",
                "commandSetResults@Display.enum": commandResultListAll.map((i) => i.label),
                "commandSetResults@Display.readOnly": false,
            };
        }

        jtype["all@Display.label"] = "  All";

        return jtype;
    }

    getCommandResultList(commandSet) {
        let commandResultList = [];
        if (commandSet !== "basicMode") {
            if (commandSet === "all") {
                this._getAllRSIIds(commandResultList);
                this._getAllConceptItems(commandResultList);
            } else {
                const allCommandSets = _.get(this._model._commandSetsFeed, "cache");
                const commandSetVal = allCommandSets[commandSet] || [];

                this._getConceptItems(commandSetVal, commandResultList);
                this._getRSIIds(commandSetVal, commandResultList);
                this._getGetURLs(commandSetVal, commandResultList);
                this._getShowCommands(commandSetVal, commandResultList);
            }
        }
        return commandResultList;
    }

    _getPristineValue(adHocEntity) {
        let pristineValue = {},
            pristineProperties = adHocEntity.getPristineProperties();

        pristineValue.searchType = pristineProperties.source || "LATEST";
        pristineValue.searchMethod = pristineProperties.filter || "NONE";

        if (pristineValue.searchMethod === "NONE") {
            pristineValue.conceptItems = undefined;
        } else if (pristineValue.searchMethod === "COMMAND") {
            pristineValue.commandSet = pristineProperties.commandSet || "all";

            if (
                pristineProperties.commandSetResult &&
                pristineProperties.commandSetResult.type === "cliCommands"
            ) {
                pristineValue.commandSetResults = `show-command.${pristineProperties.commandSetResult.command}`;
            } else if (
                pristineProperties.commandSetResult &&
                pristineProperties.commandSetResult.type === "restSyncItems"
            ) {
                pristineValue.commandSetResults = `rsi-id.${pristineProperties.commandSetResult.restSyncItemId}`;
            } else if (
                pristineProperties.commandSetResult &&
                pristineProperties.commandSetResult.type === "conceptItems"
            ) {
                pristineValue.commandSetResults = `concept-item.${pristineProperties.commandSetResult.conceptItemId}`;
            } else if (
                pristineProperties.commandSetResult &&
                pristineProperties.commandSetResult.type === "getUrls"
            ) {
                pristineValue.commandSetResults = `get-url.${pristineProperties.commandSetResult.getUrl}`;
            } else if (
                pristineProperties.commandSetResult &&
                pristineProperties.commandSetResult.type === "basicMode"
            ) {
                pristineValue.commandSetResults = "standard";
            } else if (
                pristineProperties.commandSetResult &&
                pristineProperties.commandSetResult.type === "all"
            ) {
                pristineValue.commandSetResults = "all";
            }
        } else if (pristineValue.searchMethod === "SHOW") {
            pristineValue.show = pristineProperties.showCommands || "";
        } else if (pristineValue.searchMethod === "SECTION") {
            if (pristineProperties.conceptItemId) {
                pristineValue.section =
                    `concept-item.${pristineProperties.conceptItemId}` || "none";
            } else {
                pristineValue.section = `rsi-id.${pristineProperties.rsiId}` || "none";
            }
        }

        pristineValue.searchField = pristineProperties.query || "";

        return pristineValue;
    }

    _generateResultGrid() {
        if (_.isEmpty(this._selectedTargetsGrid)) {
            this._createGrid();
        }
    }

    _createGrid() {
        this._model._gameEditor.renderer._rootElem.querySelector(
            "game-editor-view-actions-gl left-container"
        ).innerHTML = "";
        this._selectedTargetsGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.columnsResult,
            pagingFeed: this._model._adHocQueryResultEntitiesGen,
            showHeader: true,
            gridKey: `${this._model._gridKey}_selected`,
            showLinesNumber: this._model._gameEditor.renderer._rootElem.querySelector(
                "game-editor-view-actions-gl left-container"
            ),
            useUserDataStorage: false,
        });
        this._selectedTargetsGrid._renderer._emptyMessage.innerHTML = "No targets selected";
        this._registerGridListeners();
        this._configSectionContainer.appendChild(this._selectedTargetsGrid.renderer.rootElement);
        this._rootElem.appendChild(this._configSectionContainer);
    }

    _updateButtons() {
        /* Choices buttons - Start */
        let choicesEl = this._rootElem.querySelector(
            "adhoc-query-details-view-gl > .container-main > .controls-container"
        );
        choicesEl.appendChild(this._buttonsContainer);
        /* Choices buttons - End */
    }

    saveNewQuery(value, adHocEntity, auto = false) {
        if (_.get(adHocEntity.getPristineProperties(), "name", "") === this._model.activeOrgId) {
            this._model._valuesToCopyToProxy = adHocEntity.getProperties();
        }
        return this._model
            .saveAdHocQuery(adHocEntity.setName(value))
            .then((SavedEntity) => {
                if (!auto) {
                    this.selectedSavedQuery = SavedEntity.getId();
                    this._model._proxyAdHocQueryEntity = {};
                    if (!_.isEmpty(this._model._valuesToCopyToProxy)) {
                        // return this._model._getProxyEntity(this._model._valuesToCopyToProxy, );
                        return this._model._cloneEntity(SavedEntity);
                    }
                }
                return Promise.resolve();
            })
            .then(() => {
                // if(!_.isEmpty(this._model._valuesToCopyToProxy)) {
                //     // this._deviceCountUpdated();
                // }
                this._model._valuesToCopyToProxy = {};
                return Promise.resolve();
            });
    }

    _toggleDeleteButton(state) {
        if (!state) {
            this._buttonsContainer
                .querySelector(".delete-button-control")
                .classList.remove("visible");
        } else {
            this._buttonsContainer.querySelector(".delete-button-control").classList.add("visible");
        }
    }

    _toggleResetButton(state) {
        if (!state) {
            this._buttonsContainer
                .querySelector(".reset-button-control")
                .classList.remove("visible");
        } else {
            this._buttonsContainer.querySelector(".reset-button-control").classList.add("visible");
        }
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    _getUpdatedSelectedRows() {
        const selectedRows = this._selectedTargetsGrid.getSelectedRows();
        if (selectedRows.length <= 0) {
            return [];
        }
        let allAvailableRows;
        if (this._model._toggleMode) {
            allAvailableRows = this._model._selectedResults;
        } else {
            allAvailableRows = Object.keys(this._model._matchCount);
        }
        const updatedSelection = selectedRows.filter((row) => {
            if (allAvailableRows.indexOf(row) >= 0) {
                return true;
            }
            return false;
        });
        return updatedSelection;
    }

    _hideViewActions() {}

    _showViewActions() {}

    _hideLeftFooterContainer() {}

    _showLeftFooterContainer() {}

    _refreshGrid() {}

    _onDirty(state) {
        if (!state) {
            this._model._setDirty(state);
        }
    }

    _filterName(name) {
        if (_.isEmpty(name)) {
            return "no_name";
        }
        return name.replace(/\s|:|\*|\/|\\/g, "_");
    }

    _disableAllViewActions() {
        this.model.gameEditor.disableViewAction("hideShowUnmatchedResults");
        this.model.gameEditor.disableViewAction("removeUnmatchedResults");
        this.model.gameEditor.disableViewAction("selectmatchedResults");
        this.model.gameEditor.disableViewAction("editTargets");
        this.model.gameEditor.disableViewAction("downloadMatches");
        this.model.gameEditor.disableViewAction("searchButton");
    }

    _enableAllViewActions() {
        this._model.setMatchesAndFailureCount();

        if (!_.get(this._model, "_lastRunSelected", false)) {
            this.model.gameEditor.enableViewAction("editTargets");
        } else {
            this.model.gameEditor.disableViewAction("editTargets");
        }

        // if(!_.isEmpty(this._model._matchCount) || this._model._matchCount === 0) {
        // this.model.gameEditor.disableViewAction("downloadMatches");
        // } else {
        this.model.gameEditor.enableViewAction("downloadMatches");
        // }

        if (
            _.get(this._model, "_adHocRun", false) ||
            _.get(this._model, "_lastRunSelected", false)
        ) {
            if (this._model._failuresCount && !this._model._matchCount) {
                this.model.gameEditor.disableViewAction("hideShowUnmatchedResults");
                this.model.gameEditor.disableViewAction("removeUnmatchedResults");
                this.model.gameEditor.disableViewAction("selectmatchedResults");
            } else if (!this._model._failuresCount) {
                this.model.gameEditor.disableViewAction("hideShowUnmatchedResults");
                this.model.gameEditor.disableViewAction("removeUnmatchedResults");
                this.model.gameEditor.enableViewAction("selectmatchedResults");
            } else {
                this.model.gameEditor.enableViewAction("hideShowUnmatchedResults");
                this.model.gameEditor.enableViewAction("removeUnmatchedResults");
                this.model.gameEditor.enableViewAction("selectmatchedResults");
            }
        } else {
            this.model.gameEditor.disableViewAction("hideShowUnmatchedResults");
            this.model.gameEditor.disableViewAction("removeUnmatchedResults");
            this.model.gameEditor.disableViewAction("selectmatchedResults");
            this.model.gameEditor.disableViewAction("downloadMatches");
        }
    }

    _updateEntityOnChange() {
        const form = this._formsComponent.getValue(),
            selectedSavedQuery = this._adHocQueriesList.getValue(),
            currentEntity = this._model._adHocQueriesMap[selectedSavedQuery];

        if (currentEntity) {
            this._model._updateEntity(currentEntity, form);
        }

        if (this._model._proxyAdHocQueryEntity) {
            this._model._updateEntity(this._model._proxyAdHocQueryEntity, form);
        }
    }

    _getShowCommands(commandSet, resultObject) {
        const commands = commandSet.getCommands();
        if (commands && _.isArray(commands)) {
            commands.forEach((command) => {
                const exists = resultObject.find((i) => i.value === `show-command.${command}`);

                if (_.isEmpty(exists)) {
                    resultObject.push({value: `show-command.${command}`, label: command});
                }
            });
        }
    }
    _getGetURLs(commandSet, resultObject) {
        const getURLs = commandSet.getGetUrls();
        if (getURLs) {
            getURLs.forEach((getURL) => {
                const exists = resultObject.find((i) => i.value === `get-url.${getURL}`);

                if (_.trim(getURL) !== "" && _.isEmpty(exists)) {
                    resultObject.push({value: `get-url.${getURL}`, label: getURL});
                }
            });
        }
    }
    _getConceptItems(commandSet, resultObject) {
        const conceptItems = commandSet.getConceptItemIds();
        if (conceptItems) {
            conceptItems.forEach((conceptItem) => {
                const exists = resultObject.find((i) => i.value === `concept-item.${conceptItem}`);

                if (_.isEmpty(exists)) {
                    resultObject.push({
                        value: `concept-item.${conceptItem}`,
                        label: _.get(this._model._conceptItems, `${conceptItem}.label`),
                    });
                }
            });
        }
    }
    _getRSIIds(commandSet, resultObject) {
        const rsiIds = commandSet.getRsiIds();
        if (rsiIds) {
            rsiIds.forEach((rsiId) => {
                // check for unique
                const exists = resultObject.find((i) => i.value === `rsi-id.${rsiId}`);

                if (_.isEmpty(exists)) {
                    resultObject.push({
                        value: `rsi-id.${rsiId}`,
                        label: _.get(this._model._rsiIdsMap, `${rsiId}.label`),
                    });
                }
            });
        }
    }

    _getAllRSIIds(resultObject) {
        let rsiIds = [];
        rsiIds = Object.values(this._model._rsiIdsMap).map((i) => ({
            label: i.label,
            value: `rsi-id.${i.value}`,
        }));

        resultObject.push(...rsiIds);
    }
    _getAllConceptItems(resultObject) {
        let conceptItems = [];
        conceptItems = Object.values(this._model._conceptItems).map((i) => ({
            label: i.label,
            value: `concept-item.${i.value}`,
        }));

        resultObject.push(...conceptItems);
    }

    _renderConceptItemCommands() {
        const form = this._formsComponent.getValue(),
            editorRootElem = this._model._gameEditor._renderer.getRootElement();
        if (form.searchMethod !== "NONE") {
            let commandDropdownValue = "";
            if (form.searchMethod === "COMMAND") {
                const commandResultDropdown = editorRootElem.querySelector(".command_set_results");
                commandDropdownValue = form.commandSetResults;

                let result = [];
                this._toolTipContent = "";
                if (commandDropdownValue.indexOf("concept-item.") > -1) {
                    const currentConceptId = commandDropdownValue.replace(/concept-item./, "");
                    result = this._model._conceptItems[currentConceptId].showCommands;
                } else if (commandDropdownValue.indexOf("show-command.") > -1) {
                    result = commandDropdownValue.replace(/show-command./, "");
                } else if (commandDropdownValue.indexOf("rsi-id.") > -1) {
                    const currentRSIId = commandDropdownValue.replace(/rsi-id./, "");
                    result = this._model._rsiIdsMap[currentRSIId].readOperation;
                } else if (commandDropdownValue.indexOf("get-url.") > -1) {
                    result = commandDropdownValue.replace(/get-url./, "");
                } else if (commandDropdownValue === "all") {
                    result = this._getAllConfigsForTooltip();
                }

                this._toolTipContent = _.clone(result);

                this._removeOldCommandValues();

                if (_.isEmpty(_.trim(result))) {
                    return;
                }

                let commandContainer = document.createElement("div");
                commandContainer.classList.add("additional-command-container");
                let innerContainer = document.createElement("div");
                innerContainer.classList.add("additional-inner");
                this._viewMoreIcon = document.createElement("actionable-icon-gl");
                this._viewMoreIcon.dataset.icon = "configdrift.view_more";
                this._viewMoreIcon.setAttribute("title", "Command Set Result");
                commandContainer.appendChild(innerContainer);
                commandContainer.appendChild(this._viewMoreIcon);

                commandResultDropdown.appendChild(commandContainer);

                if (_.isArray(result)) {
                    let resString = "";
                    result.forEach((i) => {
                        resString += i + " ";
                    });
                    innerContainer.innerHTML = resString;
                } else {
                    innerContainer.innerHTML = result;
                }
                this._createPopUp();
            } else if (form.searchMethod === "SECTION") {
                const sectionDropdown = editorRootElem.querySelector(".search_method .section");

                // const sectionListAll = [];
                // if (form.section === "all") {
                //     this._getAllRSIIds(sectionListAll);
                //     this._getAllConceptItems(sectionListAll);

                //     commandDropdownValue = "all";
                // } else {
                if (form.section !== "none") {
                    commandDropdownValue = form.section;
                }

                let result = [];
                this._toolTipContent = "";
                if (commandDropdownValue.indexOf("concept-item.") > -1) {
                    const currentConceptId = commandDropdownValue.replace(/concept-item./, "");
                    result = this._model._conceptItems[currentConceptId].showCommands;
                } else if (commandDropdownValue.indexOf("show-command.") > -1) {
                    result = commandDropdownValue.replace(/show-command./, "");
                } else if (commandDropdownValue.indexOf("rsi-id.") > -1) {
                    const currentRSIId = commandDropdownValue.replace(/rsi-id./, "");
                    result = this._model._rsiIdsMap[currentRSIId].readOperation;
                } else if (commandDropdownValue.indexOf("get-url.") > -1) {
                    result = commandDropdownValue.replace(/get-url./, "");
                }

                this._toolTipContent = _.clone(result);

                this._removeOldCommandValues();

                if (_.isEmpty(_.trim(result))) {
                    return;
                }

                let commandContainer = document.createElement("div");
                commandContainer.classList.add("additional-command-container");
                let innerContainer = document.createElement("div");
                innerContainer.classList.add("additional-inner");
                this._viewMoreIcon = document.createElement("actionable-icon-gl");
                this._viewMoreIcon.dataset.icon = "configdrift.view_more";
                this._viewMoreIcon.setAttribute("title", "Command Set Result");
                commandContainer.appendChild(innerContainer);
                commandContainer.appendChild(this._viewMoreIcon);

                sectionDropdown.appendChild(commandContainer);

                if (_.isArray(result)) {
                    let resString = "";
                    result.forEach((i) => {
                        resString += i + " ";
                    });
                    innerContainer.innerHTML = resString;
                } else {
                    innerContainer.innerHTML = result;
                }
                this._createPopUp();
            }
        }
        return Promise.resolve();
    }

    _createPopUp() {
        if (this._rootElem === null) {
            return;
        }
        let viewMoreContentElement = document.createElement("view-more-pop-up");
        viewMoreContentElement.classList.add("command-set-results-popup");
        viewMoreContentElement.innerHTML = this._toolTipContent;
        this._popUpWidget = new PopUpWidget({
            content: viewMoreContentElement.outerHTML,
            anchor: this._viewMoreIcon,
            anchorPoint: "left",
            displayDirection: "bottomLeft",
            openOnHover: true,
            parent: viewMoreContentElement.parentNode,
        });
    }

    _getAllConfigsForTooltip(list = undefined) {
        let strRes = "";
        const form = this._formsComponent.getValue();
        let options = [];
        if (list) {
            options = list;
        } else {
            const commandResults = this.getCommandResultList(form.commandSet);

            options = commandResults;
        }

        options.forEach((item) => {
            if (item.value.indexOf("concept-item.") > -1) {
                const currentConceptItemId = item.value.replace(/concept-item./, "");
                const conceptItem = this._model._conceptItems[currentConceptItemId];
                const commands = conceptItem.showCommands;
                if (commands && _.isArray(commands)) {
                    commands.forEach((i) => {
                        strRes += i + "<br />";
                    });
                }
            }

            if (item.value.indexOf("rsi-id.") > -1) {
                const rsiId = item.value.replace(/rsi-id./, "");
                const rsiObject = this._model._rsiIdsMap[rsiId];
                const commands = rsiObject.readOperation;
                strRes += commands + "<br />";
            }

            if (item.value.indexOf("get-url.") > -1) {
                const getURL = item.value.replace(/get-url./, "");
                strRes += getURL + "<br />";
            }

            if (item.value.indexOf("show-command.") > -1) {
                const showCommand = item.value.replace(/show-command./, "");
                strRes += showCommand + "<br />";
            }
        });

        return strRes;
    }

    _removeOldCommandValues() {
        const editorRootElem = this._model._gameEditor._renderer.getRootElement();
        let oldCommandValuesCommandSetResult = editorRootElem.querySelectorAll(
            ".additional-command-container"
        );
        oldCommandValuesCommandSetResult.forEach((commandValueElem) => {
            commandValueElem.remove();
        });
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = AdhocQueryDetailsViewRenderer;
